import { getGlobalConfig } from "src/datahandling/redux/globalConfig";
import { type Environment } from "src/models/types/common.types";

export function GET_ENV() {
	return getGlobalConfig()?.APPLICATION?.ENVIRONMENT ?? ("prod" as Environment);
}

export const isInDev = () => {
	return GET_ENV() === ("dev" as Environment);
};

export const isInProd = () => {
	return GET_ENV() === ("prod" as Environment);
};
